import { Component, OnInit, OnDestroy } from '@angular/core';
import { LoadGeneratedEntities } from 'mj_generatedentities';

// Forces the generated entities library to load — prevents tree-shaking from dropping @RegisterClass decorators
LoadGeneratedEntities();

@Component({
  standalone: false,
  selector: 'app-root',
  template: '<mj-explorer-app /><izzy-profile-completion /><izzy-global-context style="display:none"></izzy-global-context>'
})
export class AppComponent implements OnInit, OnDestroy {
  private observer: MutationObserver | null = null;
  private mountTimer: ReturnType<typeof setInterval> | null = null;

  ngOnInit(): void {
    // Ensure Izzy theme overlay always stays applied.
    // ThemeService may remove it during initialization — re-apply when that happens.
    const html = document.documentElement;
    html.setAttribute('data-theme-overlay', 'izzy');

    this.observer = new MutationObserver(() => {
      if (html.getAttribute('data-theme-overlay') !== 'izzy') {
        html.setAttribute('data-theme-overlay', 'izzy');
      }
    });

    this.observer.observe(html, {
      attributes: true,
      attributeFilter: ['data-theme-overlay']
    });

    // Relocate the global org/channel switcher into the MJ shell header.
    // The shell has no content-projection slot, so we physically move the
    // component's host element into the header (Angular bindings survive a
    // DOM move — the component instance is untouched). The interval also
    // heals the mount across logout/login, when the shell header is
    // destroyed and recreated: a disconnected host is re-parked on app-root
    // until a fresh header shows up.
    this.mountTimer = setInterval(() => this.mountGlobalContext(), 500);
  }

  private mountGlobalContext(): void {
    const host = document.querySelector('app-root > izzy-global-context, .shell-header > izzy-global-context') as HTMLElement | null;
    if (!host) return;

    if (!host.isConnected) {
      // Shell header was torn down (logout) and took our element with it —
      // re-park on app-root so Angular's element reference stays in the DOM.
      document.querySelector('app-root')?.appendChild(host);
      host.style.display = 'none';
      return;
    }

    const header = document.querySelector('.shell-header');
    if (header && host.parentElement !== header) {
      // Insert where the global search used to live: before the header's
      // right-side actions cluster.
      const actions = header.querySelector('.header-actions');
      header.insertBefore(host, actions);
      host.style.display = '';
    }
  }

  ngOnDestroy(): void {
    this.observer?.disconnect();
    if (this.mountTimer) {
      clearInterval(this.mountTimer);
    }
  }
}
